/**
 * Updates the recently viewed products in localStorage.
 * Stores product handles (URL slugs) for fetching via Section Rendering API.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in localStorage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 8;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productHandle - The handle (URL slug) of the product to add.
   */
  static addProduct(productHandle) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ handle) => handle !== productHandle);
    viewedProducts.unshift(productHandle);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed product handles from localStorage.
   * @returns {string[]} The list of viewed product handles.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }
}
